import axios from "axios";
const API_URL = "https://mern-backend-kz86.onrender.com";
export const uploadFile = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/upload`, data);
    return response.data;
  } catch (error) {
    console.log("error while calling the api", error.message);
  }
};
